import { makeAutoObservable, observable, action } from 'mobx'

export class AccountActiveStore {
  constructor() {
    makeAutoObservable(this)
  }

  @observable
  isActive = false

  @action
  setIsActive(isActive: boolean) {
    this.isActive = isActive
  }
}

export const accountActiveStore = new AccountActiveStore()
